export enum NotificationBgColor {
  SUCCESS = 'green',
  ERROR = 'red',
  WARNING = 'orange',
  INFO = 'blue',
}

export enum HorizontalPosition {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum VerticalPosition {
  BOTTOM = 'bottom',
  TOP = 'top',
}

export interface NotificationPosition {
  horizontal: HorizontalPosition;
  vertical: VerticalPosition;
}
